"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Snapchat;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Snapchat(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Snapchat"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "snapchat",
    className: "cls-1",
    d: "M50,10A40,40,0,1,0,90,50,39.993,39.993,0,0,0,50,10ZM77.339,64.661c-.565,1.307-2.92,2.258-7.226,2.936a19.843,19.843,0,0,0-.694,2.564,1.241,1.241,0,0,1-1.306.952h-.032c-1,0-2.065-.468-4.162-.468-2.838,0-3.822.645-6.032,2.21-2.339,1.661-4.581,3.08-7.935,2.935-3.387.258-6.226-1.806-7.823-2.935-2.226-1.565-3.194-2.21-6.032-2.21a41.142,41.142,0,0,0-4.162.5,1.28,1.28,0,0,1-1.338-.968A20.317,20.317,0,0,0,29.9,67.6c-2.226-.339-7.226-1.21-7.338-3.452a1.139,1.139,0,0,1,.951-1.193c7.468-1.226,10.823-8.887,10.968-9.21,0-.016.016-.032.032-.048a2.414,2.414,0,0,0,.258-2.017c-.548-1.274-2.887-1.725-3.871-2.129-2.548-1-2.9-2.161-2.742-2.951.258-1.371,2.323-2.226,3.533-1.662a6.069,6.069,0,0,0,2.532.678,2.255,2.255,0,0,0,1.064-.226c-.225-3.855-.758-9.355.613-12.435a14.647,14.647,0,0,1,13.565-8.758c.1,0,.984-.017,1.08-.017a14.517,14.517,0,0,1,13.6,8.758c1.371,3.081.839,8.565.613,12.436a2.022,2.022,0,0,0,.919.226,6.346,6.346,0,0,0,2.371-.678,2.951,2.951,0,0,1,2.194,0,2.244,2.244,0,0,1,1.677,1.92c.016,1.048-.919,1.951-2.774,2.677-.226.1-.5.178-.79.274-1.049.339-2.645.839-3.065,1.855a2.477,2.477,0,0,0,.258,2.016c.017.016.017.033.033.049.145.322,3.5,7.984,10.967,9.209a1.238,1.238,0,0,1,.791,1.742Z"
  })));
}